import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Section,
  Cell,
  Textarea,
  Button,
  Placeholder,
  Text,
} from '@telegram-apps/telegram-ui';
import { useAuth } from '../hooks/useAuth';
import { useTelegram } from '../hooks/useTelegram';
import { api } from '../api/client';

export function CallbackPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { setBackButtonVisible, hapticFeedback } = useTelegram();

  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setBackButtonVisible(true, () => navigate(-1));
    return () => setBackButtonVisible(false);
  }, [setBackButtonVisible, navigate]);

  async function handleSubmit() {
    setIsLoading(true);
    setError('');

    try {
      await api.callback.request(message.trim() || undefined);
      hapticFeedback('success');
      setIsSuccess(true);
    } catch (err) {
      hapticFeedback('error');
      setError(err instanceof Error ? err.message : 'Ошибка отправки');
    } finally {
      setIsLoading(false);
    }
  }

  if (isSuccess) {
    return (
      <Placeholder
        header="Заявка отправлена!"
        description="Мы перезвоним вам в ближайшее время."
        action={
          <Button size="l" onClick={() => navigate('/')}>
            К заявкам
          </Button>
        }
      />
    );
  }

  return (
    <div style={{ padding: '16px' }}>
      <Text weight="1" style={{ fontSize: '20px', marginBottom: '16px' }}>
        Обратный звонок
      </Text>

      <Section header="Ваш номер">
        <Cell>
          {user?.phone || 'Не указан'}
        </Cell>
      </Section>

      <Section header="Сообщение (необязательно)">
        <Textarea
          placeholder="Опишите вопрос, по которому хотите поговорить..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ minHeight: '100px' }}
        />
      </Section>

      {error && (
        <Text style={{ color: 'var(--tgui--destructive_text_color)', padding: '8px 0', fontSize: '14px' }}>
          {error}
        </Text>
      )}

      <div style={{ padding: '16px 0' }}>
        <Button
          size="l"
          stretched
          onClick={handleSubmit}
          loading={isLoading}
        >
          Перезвоните мне
        </Button>
      </div>
    </div>
  );
}
